import React, { useState, useEffect } from 'react';
import { Modal, Form, Button, InputGroup } from "react-bootstrap";
import { BASE_URL } from "../../../constants";
import Select from 'react-select';
import axios from 'axios';

//const DiscountModal = ({ show, handleClose, handleSave }) => {
const EditAllotParkModal = ({ show, handleClose, onRowSelect }) => {


  const [searchVchrNo, setSearchVchrNo] = useState();
  const [searchVchrDate, setSearchVchrDate] = useState();
  const [searchCB_Code, setSearchCB_Code] = useState();
  const [searchAcct_Code, setSearchAcct_Code] = useState();
  const [searchSection, setSearchSection] = useState();

  const [searchResults, setSearchResults] = useState([]);
  const [cashBankList, setCashBankList] = useState([]);
  const [acctCodes, setAcctCodes] = useState([]);
  const [ddlSections, setDdlSections] = useState([]);

//  const [showsearchModal, setShowSearchModal] = useState(false);

  useEffect(() => {
    
    const fetchLists = async () => {
      try {
        const [AcctRes, cashBankRes, sectionRes] = await Promise.all([
            axios.get(`${BASE_URL}/api/ddl_Accnt_Mast`),
            axios.get(`${BASE_URL}/api/ddl_CashBank_Mast`),
            axios.get(`${BASE_URL}/api/ddl_sections`),
        ]);

        setAcctCodes(AcctRes.data);
        setCashBankList(cashBankRes.data);
        setDdlSections(sectionRes.data);


      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };

    fetchLists();

  }, []);

  const handleSearch = async () => {

    try {
      const response = await axios.get(`${BASE_URL}/api/get_vocuher_edit`, {
        params: {p_VchrNo: searchVchrNo || 0, p_VchrDate: searchVchrDate || '', p_CBCode: searchCB_Code || 0, 
                 p_AcctCode : searchAcct_Code || 0, p_TransType: 'PV', p_Section_Id: searchSection || 0},
      });

      setSearchResults(response.data);

    } catch (error) {
      console.error('Search failed:', error);
    }

  };

  const handleClear = async () => {
    setSearchAcct_Code('');
    setSearchVchrDate('');
    setSearchVchrNo('');
    setSearchCB_Code('');
    setSearchResults([]);

  }
  
  const options = acctCodes.map(code => ({
    value: String(code.acct_code),
    label: code.acct_name
  })) || [];

  return (
    <Modal show={show} onHide={handleClose} size="xl" centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Select Payment Voucher - Edit</Modal.Title>
      </Modal.Header>

      <Modal.Body>

        <Form className="mb-3">
          {/* === Row 1 === */}
          <div className="row mb-3">
            <Form.Group className="col-md-3">
              {/* <Form.Label>Voucher No</Form.Label> */}
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Voucher No</InputGroup.Text>
                <input style={{textAlign: 'right'}}
                  className="form-control"
                  name="searchVchrNo"
                  value={searchVchrNo}
                  onChange={(e) => setSearchVchrNo(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
            {/* <Form.Group className="col-md-2"></Form.Group> */}

            {/* Section Dropdown */}
            <Form.Group className="col-md-3">
                <Form.Select
                  value={searchSection}
                  onChange={(e) => setSearchSection(e.target.value)}>
                  <option value="">-- Section --</option>
                  {ddlSections.map(sec => (
                    <option key={sec.section_id} value={sec.section_id}>{sec.section_desc}</option>
                  ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="col-md-3">
              {/* <Form.Label>Voucher Date</Form.Label> */}
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Voucher Date</InputGroup.Text>
                <input
                  className="form-control"
                  name="searchVchrDate"
                  type="date"
                  value={searchVchrDate}
                  onChange={(e) => setSearchVchrDate(e.target.value)}
                />
              </InputGroup>
            </Form.Group>
            <div className="col-md-1">
              <Button variant="primary" onClick={handleSearch} className="w-100">
                Search
              </Button>
            </div>
            <div className="col-md-1">
                 <Button variant="secondary" onClick={handleClear} className="w-100">
                Clear
              </Button>
            </div>

          </div>

          {/* === Row 2 === */}
          <div className="row align-items-end">
            <Form.Group className="col-md-6">
              {/* <Form.Label>Cash/Bank Name</Form.Label> */}
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Cash/Bank</InputGroup.Text>
                <select
                  className="form-select"
                  name="searchCB_Code"
                  value={searchCB_Code}
                  onChange={(e) => setSearchCB_Code(e.target.value)}
                >
                  <option value="">-- Select Cash/Bank --</option>
                  {cashBankList.map((cb) => (
                    <option key={cb.cb_code} value={cb.cb_code}>
                      {cb.cb_name}
                    </option>
                  ))}
                </select>
              </InputGroup>
            </Form.Group>

            <Form.Group className="col-md-6">
              {/* <Form.Label>Account Name</Form.Label> */}
              <InputGroup>
                <InputGroup.Text style={{ width: "120px" }}>Account</InputGroup.Text>
                <div style={{ flex: 1 }}>
                  <Select name="searchAcct_Code"
                    options={options}
                    value={options.find(option => option.value === searchAcct_Code) || null}
                    onChange={(selectedOption) => setSearchAcct_Code(selectedOption?.value || "")}
                    className="w-100"
                    placeholder="-- Select Account --"
                  />
                </div>
              </InputGroup>
            </Form.Group>
          </div>
        </Form>
        {/* <Table bordered hover responsive> */}
        <div style={{ minHeight: '430px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-modal scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '7%', textAlign: 'left' }}>Section</th>
                <th style={{ width: '6%', textAlign: 'left' }}>Voucher No.</th>
                <th style={{ width: '6%', textAlign: 'center' }}>Voucher Date</th>
                <th style={{ width: '35%', textAlign: 'left' }}>Cash Bank/Account Name</th>
                <th style={{ width: '10%', textAlign: 'right' }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {searchResults.length === 0 ? (
                <tr><td colSpan="5" className="text-center">No Data</td></tr>
              ) : (
                searchResults.map((row, index) => (
                  <tr key={index} onClick={() => onRowSelect(row)} style={{ cursor: 'pointer' }}>
                    <td style={{ textAlign: 'left' }}>{row.section}</td>
                    <td style={{ textAlign: 'left' }}>{row.vchr_no}</td>
                    <td style={{ textAlign: 'center' }}>{row.vchr_date}</td>
                    <td style={{ textAlign: 'left' }}>{row.cb_acct_name}</td>
                    <td style={{ textAlign: 'right' }}>{row.vchr_amt}</td>
                  </tr>
                ))
              )}
            </tbody>
            {/* </Table> */}
          </table>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default EditAllotParkModal;
